import { gql } from '@apollo/client';

export const qualityDeleteReturnReceiptMutation = gql`
  mutation deleteReturnReceipt($returnReceiptId: ID!, $personId: Int!) {
    deleteReturnReceipt(returnReceiptId: $returnReceiptId, userPersonId: $personId) {
      message
    }
  }
`;
